import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
import dayjs from "dayjs";
import VueCryptojs from "vue-cryptojs";
import './assets/tailwind.css'

// Create application instance
const app = createApp(App); 

// Use VUEX store
app.use(store);

// Use vue router
app.use(router);

// CryptoJS for vue for encryptin data
app.use(VueCryptojs);

// Axios for communicating with backend
const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
    headers: {
        "Content-Type": "application/json",
        "x-form-key": process.env.VUE_APP_KEY,
    },
    transformRequest: [(data) => {
      // If testing, log data
      if (data && process.env.NODE_ENV == "development") {
        console.log(data);
      }

      const jsonData = JSON.stringify(data);

      // Define keys here
      const key = app.CryptoJS.enc.Utf8.parse("M2duvyzpuLHrLSVd");
      const iv = app.CryptoJS.enc.Utf8.parse("YGuJK9DCTEgcuDos");

      var encryptedData = app.CryptoJS.AES.encrypt(
        app.CryptoJS.enc.Utf8.parse(jsonData),
        key,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: app.CryptoJS.mode.CBC,
          padding: app.CryptoJS.pad.Pkcs7,
        }
      ).toString();
      
      return JSON.stringify(encryptedData);
    }],
});
app.config.globalProperties.$axios = { ...axiosInstance };

// Day.js plugins
require("dayjs/locale/da");
var updateLocale = require("dayjs/plugin/updateLocale");
var calendar = require("dayjs/plugin/calendar");
var isoWeek = require("dayjs/plugin/isoWeek");
var isBetween = require("dayjs/plugin/isBetween");
var localizedFormat = require('dayjs/plugin/localizedFormat')
var isSameOrBefore = require('dayjs/plugin/isSameOrBefore')

// Extend with plugins
dayjs.extend(updateLocale);
dayjs.extend(calendar);
dayjs.extend(isoWeek);
dayjs.extend(isBetween);
dayjs.extend(localizedFormat)
dayjs.extend(isSameOrBefore)

dayjs.locale("da");
dayjs.updateLocale("da", {
  calendar: {
    lastDay: "[I går]",
    sameDay: "[I dag]",
    nextDay: "[I morgen]",
    lastWeek: "dddd",
    nextWeek: "dddd",
    sameElse: "dddd",
  },
  weekStart: 0,
});
app.config.globalProperties.$dayjs = dayjs;

/**
 * Font awesome
 */
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// /* import specific icons */
import { faCircleInfo, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import { faChevronDown, faSpinnerThird, faPhone, faEnvelope, faLocationDot } from '@fortawesome/pro-light-svg-icons';


// /* add icons to the library */
library.add(faChevronDown, faCircleXmark, faSpinnerThird, faCircleInfo, faPhone, faEnvelope, faLocationDot);

// Add component
app.component('font-awesome-icon', FontAwesomeIcon);


// Mount application
app.mount('#app');
